export function loading(id) {
	let el = document.querySelector(id);
	if(!el) return;

	el.innerHTML = "<div class='knd-loader'></div>";
}


// wait till everything is rendered 
export function htmlReady(cb){
	// in case the document is already rendered
	if (document.readyState!='loading'){
		cb();
	}

	// modern browsers
	else if (document.addEventListener){ 
		document.addEventListener('DOMContentLoaded', cb);
	}
	// IE <= 8
	else document.attachEvent('onreadystatechange',() => {
		if (document.readyState=='complete') cb();
	});
}